<template>
    <div id="page_05" class="page">
        <div class="content">
            <div class="content_area">
                <div class="item_wrap item_left">
                    <div class="item">
                        <img src="@/assets/img/img_page_05_01.png" style="width:6.46rem;" />
                    </div>
                    <div class="item" style="margin-left:1.12rem;">
                        <p style="font-size:0.68rem;font-weight:bold;">
                            One - Click 재고/물류/판매 관리 시스템
                        </p>
                        <p style="font-size:0.54rem;line-height:0.82rem;">
                            원클릭 통합 관리 시스템을 통한 빠르고 정확한<br/>
                            재고확인, 물류발주 및 판매관리
                        </p>
                    </div>
                    <div class="clear"></div>
                </div>
                <div class="item_wrap item_right">
                    <div class="item">
                        <img src="@/assets/img/img_page_05_02.png" style="width:4.58rem;" />
                    </div>
                    <div id="item_05_02" class="item">
                        <p class="sub">
                            프리미엄 브랜드 13년 유통의 노하우
                        </p>
                        <p class="desc">
                            각 분야의 전문가들이 모여, 가맹 점주님의<br/>
                            사업 성공을 위한 꼼꼼한 맞춤형 오픈컨설팅 진행
                        </p>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Page05'
}
</script>

<style scoped>
    .content{padding-top:3.68rem;padding-bottom:4.4rem;}
    .item>p{font-size:0.88rem;line-height:0.5rem;}
    .item>p>span{border-bottom:0.1rem solid #000;}
    .item>img{width:10.096rem;height:auto;}
    #item_05_02>p.sub{font-weight:bold;font-size:0.68rem;}
    #item_05_02>p.desc{line-height:0.82rem;font-size:0.54rem;}

    @media (min-width:721px) {
        .item_right{margin-right:5.918rem;}
        .item_right>.item{margin-top:2.84rem;}
        .item_right>.item{float:right !important;}
        #item_05_02{margin-right:1.09rem;}
        #item_05_02>p{text-align:right;}
    }

    @media (max-width:720px) {
        .item_right{float:none;margin:0;margin-top:2rem;}
        .item>p{font-size:0.7rem;text-align: center;}
    }        
</style>